import React, { ComponentType } from 'react'
import _ from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import { FormatDate } from '../utils'
import { MarketingProps } from '../MarketingTag'

import { GridViewEntityItemProps, GridViewEntity } from '.'
import OutlookPopup from '../OutlookKey/OutlookPopup'

const renderLinkDefault = ({
  permalink,
  title,
  name,
  issueName
}: ResultItemRenderLinkProps) => (
  <a href={permalink} aria-label={title || '' || name || '' || issueName || ''}>
    {title || '' || name || '' || issueName || ''}
  </a>
)

export type ResultItemRenderLinkProps = Partial<ResultItemProps>

export type ResultItemProps = {
  title?: string
  name?: string
  ultimateParent?: boolean
  issueName?: string
  permalink?: string
  text?: string
  publishedDate?: string
  docType?: string
  reportType?: string
  abstract?: string
  marketing?: MarketingProps
  entityName?: string
  ratingsDisplay?: []
  entityRatings?: GridViewEntityItemProps[]
  renderLink?: ComponentType<ResultItemRenderLinkProps>
  ratingOutlook?: string
  ratingOutlookCode?: string
  sectorOutlook?: string
  sectorOutlookCode?: string
}

export type ResultItemsProps = {
  items: ResultItemProps[]
  isPrintPreview?: boolean
}
const TextAbstract = ({ text, abstract }: any) => (
  <>
    {text && <p>{ReactHtmlParser(text)}</p>}
    {abstract && <p>{ReactHtmlParser(abstract)}</p>}
  </>
)

const AddRatingSectorOutlooks = ({
  ratingOutlookCode,
  sectorOutlookCode,
  ratingOutlook,
  sectorOutlook,
  isPrintPreview,
  outlookIconClick
}: any) => (
  <>
    {sectorOutlookCode ? (
      <>
        Sector Outlook:&nbsp;
        {isPrintPreview ? (
          `${sectorOutlook}`
        ) : (
          <span
            className={sectorOutlookCode}
            onClick={outlookIconClick}
            role="button"
            onKeyDown={outlookIconClick}
            tabIndex={0}
            style={{ cursor: 'pointer' }}
          />
        )}
        <br />
      </>
    ) : null}
    {ratingOutlookCode ? (
      <>
        Rating Outlook:&nbsp;
        {isPrintPreview ? (
          `${ratingOutlook}`
        ) : (
          <span
            className={ratingOutlookCode}
            onClick={outlookIconClick}
            role="button"
            onKeyDown={outlookIconClick}
            tabIndex={0}
            style={{ cursor: 'pointer' }}
          />
        )}
        <br />
      </>
    ) : null}
    {sectorOutlookCode || ratingOutlookCode ? (
      <>
        <br />
      </>
    ) : null}
  </>
)

const renderItem = (
  index: number,
  {
    text,
    ultimateParent,
    publishedDate,
    reportType,
    abstract,
    marketing,
    entityName,
    entityRatings = [],
    renderLink: Link = renderLinkDefault,
    permalink,
    ratingOutlook,
    ratingOutlookCode,
    sectorOutlook,
    sectorOutlookCode,
    ...props
  }: ResultItemProps,
  isPrintPreview: boolean,
  outlookIconClick: () => void
) => {
  const isJapanese = _.get(marketing, 'language.slug') === 'ja'

  const reportTypeHeader =
    isJapanese &&
    reportType &&
    (reportType.toUpperCase() === 'NON-RATING ACTION COMMENTARY' ||
      reportType.toUpperCase() === 'RATING ACTION COMMENTARY')
      ? 'Commentary'
      : reportType

  return (
    <div className="column" key={index}>
      <div className="column__inner">
        <div className="heading--sub heading--tag">
          <span
            className={
              _.get(marketing, 'contentAccessType.name') === 'Premium'
                ? 'premium-report__color'
                : ''
            }
          >
            {reportType &&
            reportType.toUpperCase() === 'NON-RATING ACTION COMMENTARY'
              ? 'Commentary'
              : reportTypeHeader && `${reportTypeHeader}`}
          </span>
          {reportTypeHeader && ` / `}

          {publishedDate && FormatDate(publishedDate, 'ccc dd MMM, yyyy')}
          {entityRatings && !text && !abstract ? 'Entity' : null}
          {permalink && _.includes(permalink, 'credit-summary')
            ? ' - Credit Summary'
            : null}
          {ultimateParent ? ' - Ultimate Parent' : null}
          {entityName && ` / ${entityName}`}
        </div>
        <h3 className="heading--5">
          <Link {...props} permalink={permalink} />
        </h3>
        <AddRatingSectorOutlooks
          ratingOutlookCode={ratingOutlookCode}
          ratingOutlook={ratingOutlook}
          sectorOutlookCode={sectorOutlookCode}
          sectorOutlook={sectorOutlook}
          isPrintPreview={isPrintPreview}
          outlookIconClick={outlookIconClick}
        />
        <TextAbstract text={text} abstract={abstract} />
        {_.isEmpty(entityRatings) && !text && !abstract ? <p>-</p> : null}
        {!text && !abstract ? <GridViewEntity items={entityRatings} /> : null}
      </div>
    </div>
  )
}

export class ResultItems extends React.Component<ResultItemsProps> {
  state = {
    showOutlookPopup: false
  }

  render() {
    const { items, isPrintPreview = false } = this.props
    const { showOutlookPopup } = this.state
    const outlookIconClick = () => {
      this.setState({ showOutlookPopup: !showOutlookPopup })
    }
    return (
      <div className="column__main">
        <div className="column__three column--merge-a">
          {items
            ? items.map((item, index) =>
                renderItem(index, item, isPrintPreview, outlookIconClick)
              )
            : null}
          {showOutlookPopup && <OutlookPopup handleClick={outlookIconClick} />}
        </div>
      </div>
    )
  }
}
